module.exports = __webpack_public_path__ + "images/loader-medium.gif";


//////////////////
// WEBPACK FOOTER
// ./images/loader-medium.gif
// module id = 1574
// module chunks = 4